import { Result } from 'antd';

export function ServerErrorPage() {
  return <Result status="500" title="500" subTitle="Something went wrong on our end." />;
}
